export default "__VITE_ASSET__e247bc47__"